import http from "./http.js";

async function createContactPerson(resource, contactPerson) {
  const response = await http.post(`/isg-logistics/${resource}`, contactPerson);
  return response;
}

export {
  createContactPerson,
};